<template>
  <div>
    <h2 class="cortex-product-title">Entrinsia Cortex Product Family</h2>
    <div style="padding-left: 20px">
      Different levels of Cortex products are available so you only have to pay for features that you use.
    </div>
    <p />
    <div class ="p_table">
    <v-data-table
      :headers="headers"
      hide-default-footer
      :items="rows"
      disable-pagination
      dense
      hide-default-header
    >
    <template v-slot:header="{ props }">
        <th  v-for="head in props.headers">
          <div :class=" dark == false ? 'my-header' :
          head.value=='silver' ?'my-header-silver' :
          head.value=='gold' ? 'my-header-gold' :
          head.value=='platinum' ? 'my-header-platinum' : 
          head.value == 'titanium' ? 'my-header-titanium' : 
          'my-header'">
          {{ head.text }}
          </div>
        </th>
      </template>
    </v-data-table>
  </div>
  </div>
</template>

<script>
import {sync} from 'vuex-pathify'
export default {
  computed: {
    dark: sync("misc/dark"),
  },
  data: () => ({
    headers: [
      {
        text: 'Feature',
        value: 'feature'
      },
      {
        text: 'Cortex Silver',
        value: 'silver'
      },
      {
        text: 'Cortex Gold',
        value: 'gold'
      },
      {
        text: 'Cortex Platinum',
        value: 'platinum'
      },
      {
        text: 'Cortex Titanium',
        value: 'titanium'
      }
      ],
    rows: [
      {
        feature: 'Number of Users',
        silver: 'Unlimited',
        gold: 'Unlimited',
        platinum: 'Unlimited',
        titanium: 'Unlimited',
      },
      {
        feature: 'Task Management',
        silver: 'Included',
        gold: 'Included',
        platinum: 'Included',
        titanium: 'Included',
      },
      {
        feature: 'Mobile App',
        silver: 'Included',
        gold: 'Included',
        platinum: 'Included',
        titanium: 'Included',
      },
      {
        feature: 'Notification',
        silver: 'Included',
        gold: 'Included',
        platinum: 'Included',
        titanium: 'Included',
      },
      {
        feature: 'Dashboards',
        silver: 'Included',
        gold: 'Included',
        platinum: 'Included',
        titanium: 'Included',
      },
      {
        feature: 'Reports',
        silver: 'Included',
        gold: 'Included',
        platinum: 'Included',
        titanium: 'Included',
      },
      {
        feature: 'Label Generation',
        silver: 'Included',
        gold: 'Included',
        platinum: 'Included',
        titanium: 'Included',
      },
      {
        feature: 'Mothers and Clones',
        silver: 'Included',
        gold: 'Included',
        platinum: 'Included',
        titanium: 'Included'
      },
      {
        feature: 'Planting Management',
        silver: 'Included',
        gold: 'Included',
        platinum: 'Included',
        titanium: 'Included'
      },
      {
        feature: 'Plant Management',
        silver: 'Included',
        gold: 'Included',
        platinum: 'Included',
        titanium: 'Included',
      },
      {
        feature: 'Harvest Management',
        silver: 'Included',
        gold: 'Included',
        platinum: 'Included',
        titanium: 'Included',
      },
      {
        feature: 'METRC Tag Management',
        silver: 'Included',
        gold: 'Included',
        platinum: 'Included',
        titanium: 'Included',
      },
      {
        feature: 'Automatic METRC Uploads',
        silver: 'Included',
        gold: 'Included',
        platinum: 'Included',
        titanium: 'Included',
      },
      {
        feature: 'Number of Active METRC tags',
        silver: '1000',
        gold: '5000',
        platinum: '10000',
        titanium: '100,000',
      },
      {
        feature: 'Number of Facilities',
        silver: '1',
        gold: '5',
        platinum: '10',
        titanium: 'Unlimited',
      },
      {
        feature: 'Email Support',
        silver: 'Standard',
        gold: 'Priority',
        platinum: 'Priority',
        titanium: 'Priority',
      },
      {
        feature: 'Phone Support',
        silver: 'Not Available',
        gold: 'Limited',
        platinum: 'Included',
        titanium: 'Included',
      },
      {
        feature: 'Backups',
        silver: 'Not Available',
        gold: 'Monthly',
        platinum: 'Weekly',
        titanium: 'Nightly'
      },
      {
        feature: 'Automated Scale Readings',
        silver: 'Not Available',
        gold: 'Optional',
        platinum: 'Optional',
        titanium: 'Optional',
      },
      {
        feature: 'Plant and Env Sensors',
        silver: 'Not Available',
        gold: 'Optional',
        platinum: 'Optional',
        titanium: 'Optional',
      },
      {
        feature: 'Distribution Module',
        silver: 'Not available',
        gold: 'Included',
        platinum: 'Included',
        titanium: 'Included',
      },
      {
        feature: 'Sales Order Management',
        silver: 'Not available',
        gold: 'Included',
        platinum: 'Included',
        titanium: 'Included',
      },
      {
        feature: 'Automated Inventory Alerts',
        silver: 'Not available',
        gold: 'Included',
        platinum: 'Included',
        titanium: 'Included',
      },
      {
        feature: 'Package Management',
        silver: 'Limited',
        gold: 'Included',
        platinum: 'Included',
        titanium: 'Included',
      },
      {
        feature: 'Manufacturing Module',
        silver: 'Not available',
        gold: 'Optional',
        platinum: 'Optional',
        titanium: 'Optional',
      },
      {
        feature: 'Consulting Services',
        silver: 'Optional',
        gold: 'Optional',
        platinum: 'Optional',
        titanium: 'Optional',
      },
      {
        feature: 'Price',
        silver: 'FREE',
        gold: 'Request Quote',
        platinum: 'Request Quote',
        titanium: 'Request Quote',
      }
    ]
  })
  
}
</script>
<style >
.cortex-product-title {
  font-size: 1.5rem;
  padding-top: 20px;
  padding-left: 20px;
}
.p_table {
  margin: 20px;
}

.my-header-silver {
  font-size: 1rem;
  color: silver;
  text-align: left;
}
.my-header-gold {
  font-size: 1rem;
  color: #FFD700;
  text-align: left;
}
.my-header-platinum {
  font-size: 1rem;
  color: #E5E4E2;
  text-align: left;
}
.my-header-titanium {
  font-size: 1rem;
  color:#807d7f;
  text-align: left;
}
.my-header {
  font-size: 1rem;
  text-align: left;
}
</style>